import React, { Component } from 'react';
import { CardElement, injectStripe } from 'react-stripe-elements';
import { Button } from 'framework7-react';
import II18 from '../translate/II18';
import PropTypes from 'prop-types';

// noinspection CheckTagEmptyBody
class CardSection extends Component {
  state = {
    cardInvalid: true
  };

  handleSubmit = ev => {
    const thiss = this;
    ev.preventDefault();

    const cardElement = this.props.elements.getElement('card');
    this.startProcessing();
    this.props.stripe
      .confirmCardPayment(this.props.stripeClientSecret, {
        payment_method: {
          card: cardElement
        }
      })
      .then(function(result) {
        thiss.stopProcessing();
        if (result.error) {
          if (
            result.error.payment_intent &&
            result.error.payment_intent.status === 'succeeded'
          ) {
            thiss.props.onPaymentSuccess();
          } else {
            // Show error to your customer (e.g., insufficient funds)

            thiss.props.onPaymentError(result.error.message);
          }
        } else {
          // The payment has been processed!
          if (result.paymentIntent.status === 'succeeded') {
            thiss.props.onPaymentSuccess();
          } else thiss.props.onPaymentError();
        }
      });
  };

  startProcessing = () => {
    this.$f7.dialog.preloader(II18.get('dialog_processing'));
  };

  stopProcessing = () => {
    this.$f7.dialog.close();
  };

  cardChange = e => {
    const typeEnabled = this.props.paymentMethodTypes.includes(
      e.brand.toUpperCase()
    );
    this.setState({ cardInvalid: !e.complete || !typeEnabled });
  };

  render() {
    const { amount, paymentMethodTypes } = this.props;
    const formattedAmount = new Intl.NumberFormat('de-DE', {
      style: 'currency',
      currency: 'EUR'
    }).format(amount);
    return (
      <div>
        <CardElement
          onChange={this.cardChange}
          style={{ base: { fontSize: '14px' } }}
        />

        <div style={{ display: 'flex' }}>
          {paymentMethodTypes.includes('AMEX') && (
            <div className="ecard card-amex"></div>
          )}
          {paymentMethodTypes.includes('MAESTRO') && (
            <div className="ecard card-maestro"></div>
          )}
          {paymentMethodTypes.includes('MASTERCARD') && (
            <div className="ecard card-mastercard"></div>
          )}
          {paymentMethodTypes.includes('VISA') && (
            <div className="ecard card-visa"></div>
          )}
        </div>
        <br />
        <Button
          onClick={this.handleSubmit}
          className={'payButton'}
          fill
          disabled={this.state.cardInvalid}
          style={{ maxWidth: 400, margin: '0 auto' }}
        >
          <II18 params={formattedAmount}>payment_pay_x</II18>
        </Button>
      </div>
    );
  }
}

CardSection.propTypes = {
  stripe: PropTypes.object,
  elements: PropTypes.object,
  stripeClientSecret: PropTypes.string,
  paymentMethodTypes: PropTypes.array,
  amount: PropTypes.number,
  onPaymentSuccess: PropTypes.func,
  onPaymentError: PropTypes.func
};

export default injectStripe(CardSection);
